import React from "react";
import "./styles/highlights.css";

const highlightItems = [
	{
		tag: "PROJECT",
		title: "Featured project title goes here",
		description:
			"A short description of what this project does, the problem it solves, and what makes it interesting. Two to three lines.",
		actionText: "View project",
		actionHref: "#projects",
	},
	{
		tag: "ESSAY",
		title: "Featured essay or blog post title",
		description:
			"A line or two about what this piece explores – the idea, the argument, or the story. Enough to make someone curious.",
		actionText: "Read essay",
		actionHref: "#blog",
	},
	{
		tag: "TALK",
		title: "Featured talk or speaking moment",
		description:
			"What you spoke about, where, and why it mattered. A brief glimpse at the thinking behind the stage presence.",
		actionText: "See talk",
		actionHref: "#public-speaking",
	},
];

const Highlights = () => {
	return (
		<section className="highlights-section">
			<div className="highlights-grid">
				{highlightItems.map((item, index) => (
					<article className="highlight-card" key={index}>
						<div className="highlight-tag">{item.tag}</div>
						<h3 className="highlight-title">{item.title}</h3>
						<p className="highlight-description">
							{item.description}
						</p>
						<a className="highlight-link" href={item.actionHref}>
							{item.actionText} ↗
						</a>
					</article>
				))}
			</div>
		</section>
	);
};

export default Highlights;
